import { ButtonHTMLAttributes, FC, useRef } from 'react'

import CaretIcon from '@/components/CaretIcon'

import IconButton from './IconButton'

export const ScrollTopButton: FC<{ isActive: number } & ButtonHTMLAttributes<HTMLButtonElement>> = ({ isActive, ...rest }) => {
  const isRendered = useRef<boolean>(!!isActive)
  if (isActive && !isRendered.current) {
    isRendered.current = true
  }
  if (!isRendered.current) {
    return null
  }
  return (
    <IconButton
      {...rest}
      className={`z-[48] animate-fade-in-up ${
        isActive ? 'fixed bottom-24 right-2 h-10 w-10 !rounded-full p-2 shadow-md sm:right-4 md:right-8 2xl:right-[calc(50%-640px)]' : 'hidden'
      }`}
      onClick={() => window?.scrollTo?.({ top: 0, behavior: 'smooth' })}
    >
      <CaretIcon contentOpen={true} className='h-full w-full text-current' />
    </IconButton>
  )
}
export default ScrollTopButton
